import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import _ from 'lodash';

import {
  ServiceCenterItem,
} from '@/components';

export default {
  name: 'ServiceCenterPicker',
  components: {
    [ServiceCenterItem.name]: ServiceCenterItem,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
    isUpdate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
    search: '',
    searchWatch: '',
    cityId: '',
    citiesFiltered: [],
  }),
  computed: {
    ...mapGetters('appointment', {
      depotId: 'getDepotId',
      favouredDepotId: 'getFavouredDepotId',
      depotIds: 'getDepotIds',
      maintenanceDepotIds: 'getMaintenanceDepotIds',
      serviceType: 'getServiceType',
      vehiculeType: 'getVehiculeType',
      customerDataRaw: 'getCustomerDataRaw',
      licenseplate: 'getLicensePlate',
      personalData: 'getPersonalData',
      company: 'getCompany',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
      garageSearchResults: 'getGarageSearchResults',
    }),
    ...mapGetters('city', {
      cities: 'getCities',
    }),
    disableServiceCenterPicker() {
      return (this.serviceType === 'change' && !this.isNewCustomer && this.customerDataRaw.depotId !== 0) ||
        (this.serviceType === 'new-tires' && !this.isLeaseOrFleet && !this.isNewCustomer && this.customerDataRaw.depotId !== 0);
    },
    isLeaseOrFleet() {
      return this.vehiculeType === 'lease' || this.vehiculeType === 'fleet';
    },
    isNewCustomer() {
      return this.customerDataRaw.customerType === 'unknown';
    },
    showWrongDepotMessage() {
      const depot = this.customerDataRaw.depotIds.find(g => g === this.customerDataRaw.depotId);
      return this.company !== '' && depot === undefined && this.customerDataRaw.depotId !== 0;
    },
    depot() {
      if (this.garageSearchResults.length > 0) {
        const depot = this.garageSearchResults.find(g => g.depotId === this.depotId);
        return depot;
      }

      if (this.serviceType !== 'maintenance' && this.favouredDepotId !== 0) {
        const depot = this.garages.find(g => g.depotId === this.favouredDepotId);
        return depot;
      }
      return null;
    },
    isMaintenance() {
      return this.serviceType === 'maintenance';
    },
  },
  methods: {
    ...mapActions('garage', {
      searchGarages: 'SEARCH_GARAGES',
      getGarages: 'SEARCH_GARAGES',
      getMaintenanceGarages: 'FETCH_MAINTENANCE_GARAGES',
      fetchMaintenanceGaragesByLeaseId: 'FETCH_MAINTENANCE_GARAGES_BY_LEASE_ID',
    }),
    ...mapActions('city', {
      getCities: 'FETCH_DATA_CITIES',
    }),
    ...mapMutations('appointment', {
      setDepotMutation: 'SET_DEPOT',
    }),
    ...mapMutations('garage', {
      setGarageSearchResults: 'APPEND_GARAGE_SEARCH_RESULTS',
    }),
    openPopup() {
      if (!this.disabled) {
        if (!this.disableServiceCenterPicker) {
          this.isOpen = true;
          document.getElementById('app').style.overflow = 'hidden';
        }
      }
    },
    closePopup() {
      this.isOpen = false;
      this.searchWatch = '';
      document.getElementById('app').style.overflow = 'unset';
    },
    setServiceCenter() {
      this.closePopup();
    },
    searchList: _.debounce(function () {
      this.search = this.searchWatch;
      this.setCities();
    }, 350),
    setCities() {
      if (this.search.length > 1) {
        const searchLowerCase = this.search.toLowerCase();
        this.citiesFiltered = this.cities.filter(c => c.City.toLowerCase().startsWith(searchLowerCase) || c.ZipCode.toString().startsWith(searchLowerCase));
      } else {
        this.citiesFiltered = [];
      }
    },
    searchCityKeybordEvents(e) {
      const elements = document.getElementsByClassName('a-search-button__result');
      if ((e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) || elements.length === 0) {
        return;
      }

      // Enter
      if (e.keyCode === 13) {
        const highlightElements = document.getElementsByClassName('highlight');
        if (highlightElements.length > 0) {
          this.cityId = highlightElements[0].getAttribute('data-id');
          const city = highlightElements[0].getAttribute('data-city');
          const zipCode = highlightElements[0].getAttribute('data-zip-code');
          const label = `${city} - ${zipCode}`;
          this.searchGaragesByCityId(this.cityId, label);
        }
        return;
      }

      // Set current index
      let currentHighlightIndex = -1;
      for (let index = 0; index < elements.length; index += 1) {
        if (elements[index].classList.contains('highlight')) {
          currentHighlightIndex = index;
        }
      }

      // Clear all highlights
      for (let index = 0; index < elements.length; index += 1) {
        elements[index].classList.remove('highlight');
      }

      // Keydown
      if (e.keyCode === 40) {
        if (elements.length > currentHighlightIndex + 1) {
          elements[currentHighlightIndex + 1].classList.add('highlight');
        }
      }

      // Keyup
      if (e.keyCode === 38) {
        if (currentHighlightIndex > 0) {
          elements[currentHighlightIndex - 1].classList.add('highlight');
        }
        if (currentHighlightIndex === 0) {
          elements[0].classList.add('highlight');
        }
      }

      // Scrolltop
      const highlightElements = document.getElementsByClassName('highlight');
      if (highlightElements.length > 0) {
        const topPos = highlightElements[0].offsetTop;
        document.getElementsByClassName('a-search-button__results-list')[0].scrollTop = topPos;
      }
    },
    async searchGaragesByCityId(cityId, label) {
      this.searchWatch = label;
      this.citiesFiltered = [];

      const depotIds = this.isMaintenance ? this.maintenanceDepotIds : this.depotIds;

      const searchGaragesRequestModel = {
        cityId: cityId !== undefined ? cityId : null,
        depotsIds: depotIds !== 'undefined' ? depotIds : [],
        licenseplate: this.licenseplate,
        leaseId: this.personalData.leasingCompanyId,
        company: this.company,
        isMaintenance: this.isMaintenance,
        isKnownCustomer: this.customerDataRaw.customerType !== 'unknown',
      };
      // search for maintenance garages if isMaintenance is true
      await this.searchGarages(searchGaragesRequestModel);
    },
    createSearchGaragesRequestModel() {
      const depotIds = this.isMaintenance ? this.maintenanceDepotIds : this.depotIds;

      return {
        CityId: null,
        DepotsIds: depotIds || [],
        Licenseplate: this.licenseplate,
        LeaseId: this.personalData.leasingCompanyId || 0,
        Company: this.company || '',
        isMaintenance: this.isMaintenance || false,
      };
    },
  },
  watch: {
    searchWatch() {
      this.searchList();
    },
  },
  created() {
    this.setGarageSearchResults([]);
    if (this.isMaintenance) {
        this.$emit('loading-start');
        this.fetchMaintenanceGaragesByLeaseId({
          leaseId: this.personalData.leasingCompanyId,
          licencePlate: this.licenseplate,
          company: this.company,
        }).then(() => {
          this.$emit('loading-end');
          if (this.garageSearchResults.length === 0) {
            this.$router.push('/error/no-maintenance-service-centers');
          }
        });
    } else {
      const searchGarageRequestModel = this.createSearchGaragesRequestModel();
      this.getGarages(searchGarageRequestModel);
      if (!this.isUpdate) {
        this.setDepotMutation(this.favouredDepotId);
      }
    }
    if (this.cities.length === 0) {
      this.getCities();
    }
  },
};
